import Utils from '@/core/utils/Utils';
import ProductionSitesDAO from '@/domains/ProductionSites/ProductionSitesDAO';
import ProductionSite from '@/domains/ProductionSites/ProductionSite';
import Partner from '@/domains/Partners/Partner';
import Company from '@/domains/Companies/Company';

/**
 * Сервис производственных площадок
 */
class ProductionSitesService {

    /**
     * Загружает площадку по id
     */
    static async get(id: string): Promise<ProductionSite | null> {
        const response = await ProductionSitesDAO.get(id);
        return Utils.hydrate(response.data, ProductionSite.fromServer);
    }

    /**
     * Загружает список площадок
     */
    static async getList(
        partner?: Partner | null,
        company?: Company | null
    ): Promise<ProductionSite[]> {
        const response = await ProductionSitesDAO.getList(
            partner?.id ?? null,
            company?.id ?? null
        );
        return Utils.hydrateArray(response.data, ProductionSite.fromServer);
    }

    /**
     * Вынесены в сервис, так как появилося второй потребитель
     * Площадки партнёра в виде опций фильтра реестра. id вложен объектом,
     * т.к. бэкенд ждёт его в параметре фильтра как buyerProductionSite->id;
     * siteId — плоский идентификатор опции для источника (setIdentity).
     * toString — подпись опции: VSelectV2 выводит опции через toString().
     */
    static async getFilterOptions(partner: Partner | null): Promise<any[]> {
        if (!partner?.id) return [];

        const sites = await this.getList(partner);

        return sites.map(site => ({
            siteId:   site.id,
            name:     site.name,
            id:       { id: site.id },
            toString: () => site.name,
        }));
    }
}

export default ProductionSitesService;
